import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines multiple class strings together and resolves any Tailwind CSS conflicts
 * @param {...string} inputs - Class names to be combined
 * @returns {string} - Merged class name string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
